import React from 'react'
// import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'
// import {remCalc} from '../../../theme/_utils'
// NUOVA SU KENWOOD
const FavouriteHoverIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M16.99 1C15.16 1 13.41 1.9 12.04 3.39C10.55 1.88 8.82 1 7 1C2.89 1 0 3.95 0 8.67C0 12.24 2.01 15.84 5.73 19.36C6.67 20.35 12 24.18 12 24.18C12 24.18 17.19 20.42 18.28 19.35C21.99 15.84 24 12.24 24 8.67C24 3.97 21.06 1 16.99 1ZM16.9 17.91C15.86 18.92 12.02 21.8 12.02 21.8C11.94 21.75 8.02 18.87 7.14 17.95C3.75 14.74 2 11.61 2 8.67C2 5.04 4 3 7.01 3C8.48 3 10 3.93 11.31 5.56L12.14 6.6L12.91 5.51C14.01 3.95 15.52 3 17 3C19.96 3 22.01 5.07 22.01 8.67C22.01 11.6 20.26 14.73 16.91 17.91H16.9Z"
                fill="#D11B59"
            />
        </Icon>
    )
}

export default FavouriteHoverIcon
